import Vue from 'vue'
import { mapGetters } from 'vuex'
import skillableMixin from './skillableMixin'
import {
  BROWSE_JOBS,
  BROWSE_JOBS_BY_SKILL,
  BROWSE_VACANCIES_BY_SKILL,
  FREELANCERS_LIST,
  FREELANCERS_LIST_BY_SKILL,
  LANDING,
  SERVICE_BY_SKILL,
  SERVICES,
  VACANCIES,
} from '@/constants/routes'
import Skill from '@/models-ts/Skill'
import { SubcategoriesWithSkills } from '@/store/shared/modules/skills/types'

export default Vue.extend<any, any, any, any>({
  mixins: [skillableMixin],
  computed: {
    ...mapGetters({
      categories: 'skills/getCategories',
      getChilds: 'skills/getChilds',
    }),
    isGigs() {
      return this.$route.name === SERVICES || this.$route.name === SERVICE_BY_SKILL
    },
    isJobs() {
      return this.$route.name === BROWSE_JOBS || this.$route.name === BROWSE_JOBS_BY_SKILL
    },
    isFreelancers() {
      return this.$route.name === FREELANCERS_LIST || this.$route.name === FREELANCERS_LIST_BY_SKILL
    },
    isVacancies() {
      return this.$route.name === VACANCIES || this.$route.name === BROWSE_VACANCIES_BY_SKILL || this.$route.name === LANDING
    },
    sortedCategories() {
      const array = [...this.categories]
      return array.sort(this.skillSortComparator)
    },
  },
  methods: {
    skillSortComparator(a: Skill, b: Skill) {
      const aI = SORTED_URLS.findIndex((url) => url === a.url)
      const bI = SORTED_URLS.findIndex((url) => url === b.url)
      return aI > bI ? 1 : -1
    },
    getSkillUrl(skill: Skill) {
      if (this.isGigs) {
        return { name: SERVICE_BY_SKILL, params: { skill: skill.url } }
      }
      if (this.isJobs) {
        return { name: BROWSE_JOBS_BY_SKILL, params: { skill: skill.url } }
      }
      if (this.isFreelancers) {
        return { name: FREELANCERS_LIST_BY_SKILL, params: { skill: skill.url } }
      }
      if (this.isVacancies) {
        return { name: BROWSE_VACANCIES_BY_SKILL, params: { skill: skill.url } }
      }
    },
    hasSubCategoryContent(skill: SubcategoriesWithSkills): boolean {
      return skill.subCategory === 'Other' ? skill.skills.some(this.hasContent) : this.hasContent(skill.subCategory)
    },
    hasContent(skill: Skill): boolean {
      const check = (skill: Skill) => {
        if (this.isGigs) return Boolean(skill.meta?.count?.gigs)
        if (this.isJobs) return Boolean(skill.meta?.count?.jobs)
        if (this.isFreelancers) return Boolean(skill.freelancers_start_of_month_counter)
        if (this.isVacancies) return Boolean(skill.meta?.count?.vacancies)
      }
      if (check(skill)) return true
      const childs = this.getChilds(skill.id)
      return childs.some(check)
    },
  },
})

const SORTED_URLS = [
  'blockchain-and-crypto',
  'development',
  'design-and-creative',
  'nft',
  'sales-and-marketing',
  'ai',
  'writing',
  'engineering-and-architecture',
  'translation',
  'it-and-networking',
  'legal',
  'support',
  'customer-service',
  'accounting-and-consulting',
  'gaming',
  'audio-and-video',
  'offline',
  'influencers',
  'article-writing',
]
